import { translations } from "../../translations"
import styles from "./AboutMeWindow.module.css"
import SkillCircle from "./SkillCircle"

const skills = [
    { name: "PHP", src: "/images/icons/skills/php.svg" },
    { name: "Laravel", src: "/images/icons/skills/laravel.svg" },
    { name: "TypeScript", src: "/images/icons/skills/typescript.svg" },
    { name: "JavaScript", src: "/images/icons/skills/javascript.svg" },
    { name: "Java", src: "/images/icons/skills/java.svg" },
    { name: "React", src: "/images/icons/skills/react.svg" },
    { name: "React Native", src: "/images/icons/skills/react_native.svg" },
    { name: "HTML", src: "/images/icons/skills/html.svg" },
    { name: "CSS", src: "/images/icons/skills/css.svg" },
    { name: "Postgres", src: "/images/icons/skills/postgresql.svg" },
    { name: "Figma", src: "/images/icons/skills/figma.svg" },
    { name: "Photoshop", src: "/images/icons/skills/photoshop.svg" }
]

export default function SkillsSection() {
    return (
        <section className={styles.section}>
            <div className={styles.sectionTitleRow}>
                <img src="/images/icons/books.svg" className={styles.sectionIconImg} alt="" />
                <h2 className={styles.sectionTitle}>{translations('about_me.skills')}</h2>
            </div>
            <div className={styles.skillsRow}>
                {skills.map((s, index) => (
                    <SkillCircle 
                        key={s.name} 
                        name={s.name} 
                        src={s.src} 
                        hoverRate={0.8 + (index * 0.05)}
                    />
                ))}
            </div>
        </section>
    )
}
